"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@emotion/core");
var _feCoCarousel = _interopRequireDefault(require("@domain-group/fe-co-carousel"));
var _listing = _interopRequireDefault(require("../../models/listing"));
var _smallCard = _interopRequireDefault(require("../small-card"));
var styles = _interopRequireWildcard(require("./carousel-slide.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class CarouselSlide extends _react.default.Component {
  constructor(props) {
    super(props);
    this.setActiveIndex = this.setActiveIndex.bind(this);
  }
  setActiveIndex(prevIndex, newIndex) {
    // This is quite hacky but the other option was adding the index as a state.
    // This would however re-render the entire component when updated
    // which would be bit overkill for just wanting to update this section.
    // Suggestions for a better solution are welcome.
    if (prevIndex !== newIndex) {
      this.indexBox.innerHTML = newIndex + 1;
    }
  }
  render() {
    var listings = this.props.listings.slice(0, this.props.maxColumns);
    return (0, _core.jsx)(_core.ClassNames, null, _ref => {
      var css = _ref.css;
      return (0, _core.jsx)("div", null, (0, _core.jsx)(_feCoCarousel.default, {
        autoplay: false // this.props.listings.length > 1}
        ,
        autoplaySpeed: 5000,
        infinite: true,
        dots: true,
        dotsClass: css(styles.carouselDots),
        arrows: false,
        slidesToShow: 1,
        beforeChange: this.setActiveIndex
      }, listings.map((listing, index) => (0, _core.jsx)("div", {
        key: listing.url
      }, (0, _core.jsx)(_smallCard.default, {
        displayType: "carousel",
        title: this.props.title,
        onClick: () => {
          this.props.onClick(listing, index);
        },
        listing: listing,
        appearance: "sidebar"
      })))), (0, _core.jsx)("div", {
        css: styles.sliderPage
      }, (0, _core.jsx)("span", {
        ref: indexBox => {
          this.indexBox = indexBox;
        }
      }, "1"), "/", listings.length));
    });
  }
}
CarouselSlide.propTypes = {
  listings: _propTypes.default.arrayOf(_propTypes.default.shape(_listing.default)),
  maxColumns: _propTypes.default.number,
  title: _propTypes.default.string,
  onClick: _propTypes.default.func
};
CarouselSlide.defaultProps = {
  listings: [],
  maxColumns: undefined,
  title: 'Property of the Week',
  onClick: () => {}
};
var _default = exports.default = CarouselSlide;